import { createFileRoute } from '@tanstack/react-router'
import { PageContent } from '@/components/PageContent'
import { PageHeader } from '@/components/PageHeader'
import { OrganisationAccountSettings } from '@/features/settings/OrganisationAccountSettings'

export const Route = createFileRoute('/_auth/$orgSlug/account/')({
  head: () => ({ meta: [{ title: 'Account - Snowvault' }] }),
  component: RouteComponent
})

function RouteComponent() {
  const { userOrgProfile } = Route.useRouteContext().user

  if (!userOrgProfile) return null

  return (
    <>
      <PageHeader breadcrumbs={[{ label: 'Account' }]} />
      <PageContent>
        <OrganisationAccountSettings userOrgProfile={userOrgProfile} />
      </PageContent>
    </>
  )
}
